module.exports = __webpack_public_path__ + "img/05.c894f8d7.jpg";